import { Component } from '@angular/core'
import { IonicPage, NavController, NavParams, AlertController, ItemSliding, ToastController } from 'ionic-angular'

import { FormControl } from '@angular/forms'
import { debounceTime } from 'rxjs/operators/debounceTime'

import { ControlPanelPage } from '../control-panel/control-panel'
import { CondominiumProvider } from '../../providers/condominium/condominium'
import { AuthProvider } from '../../providers/auth/auth'

import { CondominiumWritePage } from '../condominium-write/condominium-write'
import { UserAddPage } from '../user-add/user-add'

import { Condominium, User } from '../../models/models'

@IonicPage()
@Component({
	selector: 'page-condominium-index',
	templateUrl: 'condominium-index.html',
})
export class CondominiumIndexPage {
	/*
	Se non null indica l'utente di riferimento
	*/
	user: User = null;

	isLoading = true;
	searchTerm: string

	searchControl: FormControl

	allCondominiums: Condominium[] = [];
	administrateds: Condominium[] = [];
	owneds: Condominium[] = [];
	resideds: Condominium[] = [];
	heatingreads: Condominium[] = [];
	workeds: Condominium[] = [];
	others: Condominium[] = [];

	itemSliding: ItemSliding = null;

	/*
	salva l'eventuale condominio di riferimento
	*/
	constructor(
		public auth: AuthProvider,
		private alertCtrl: AlertController,
		private condominiums: CondominiumProvider,
		private nav: NavController,
		private navParams: NavParams,
		private toastCtrl: ToastController
	) {
		this.user = navParams.get('user')//utente per filtrare i condomnini
		this.searchControl = new FormControl()
	}
	public goToControlPanel() {
		this.nav.setRoot(ControlPanelPage)
	}
	goToUserAdd(permission: string = null) {
		let options = {}
		if(permission) {
			options['is_' + permission] = true
		}
		this.nav.push(UserAddPage, options)
	}

	goToCondominiumCreate() {
		this.nav.push(CondominiumWritePage)
	}


	/*
	Quando il DOM ha finito di caricare
	*/
	ionViewDidLoad() {
		let self = this

		this.searchControl.valueChanges
			.pipe(debounceTime(1000))
			.subscribe(search => {//quando cambia i termini di ricerca aspetta X millisecondi prima di fare un caricamento da web
				console.log("Filtro condomini: " + search)
				self.refresh()
			})
	}

	/*
	quando sta per visualizzare o rivisualizzare la pagina
	*/
	ionViewWillEnter() {
		this.refresh()//Quando visualizza la pagina aggiorna gli utenti
	}

	/*
	quando cambiano i termini della ricerca
	*/
	onSearchInput() {//Quando cambia i termini di ricerca va immediatamente in loading
		this.isLoading = true
	}

	refresh() {
		console.log('Refresh elenco condomini..')
		let self = this
		this.isLoading = true
		self.administrateds = []
		self.owneds = []
		self.resideds = []
		self.heatingreads = []
		self.workeds = []
		self.others = []
		self.allCondominiums = []


		self.condominiums.index(
			self.user && (self.user.is_operator || self.user.is_admin) ? null : self.user,
			['address', 'housingUnits', 'housingUnits.userRoles'],
			undefined,
			this.searchTerm
		)
			.then((condominiums: Condominium[]) => {
				if(condominiums) {
					self.allCondominiums = condominiums
					if(self.user) {
						for(let c of condominiums) {
							let isSomething = false

							for(let hu of c.housing_units) {
								//contollo se è residente o proprietario in una delle unità immobiliari

								for(let role of hu.user_roles) {
									if(role.user_id == self.user.id) {
										if(role.is_owner) {
											isSomething = true
											self.owneds.push(c)
										}
										if(role.is_resident) {
											isSomething = true
											self.resideds.push(c)
										}
										break//per questa unità abbiamo finito
									}
								}
							}

							/*
							controlla se ha un ruolo nel condominio
							non carica tutti gli utenti insieme per motivi di sicurezza
							*/
							for(let administrator of c.administrators) {
								if(administrator.id == self.user.id) {
									self.administrateds.push(c)
									isSomething = true
									break
								}
							}
							for(let worker of c.workers) {
								if(worker.id == self.user.id) {
									self.workeds.push(c)
									isSomething = true
									break
								}
							}
							for(let heatingreader of c.heatingreaders) {
								if(heatingreader.id == self.user.id) {
									self.heatingreads.push(c)
									isSomething = true
									break
								}
							}

							if(!isSomething) {
								//se non è nulla va nell'elenco di chi non ha privilegi
								self.others.push(c)
							}
						}
					}
				} else {
					let toast = self.toastCtrl.create({
						message: 'Potrebbe essersi verificato un errore recuperando i condomini',
						position: 'middle',
						duration: 3000,
						cssClass: "danger"
					})
					toast.present()
				}

				self.isLoading = false
			}).catch(error => {
				let toast = self.toastCtrl.create({
					message: 'Errore recuperando i condomini',
					position: 'middle',
					duration: 3000,
					cssClass: "danger"
				})
				toast.present()
				console.error('Errore recuperando i condomini:', error)
				self.isLoading = false
			})
	}

	showDestroyCondominiumConfirm(menu, condominium: Condominium) {
		menu.close()
		let self = this
		let confirm = this.alertCtrl.create({
			title: "Eliminare il condominio dal server?",
			message: "Vuoi davvero eliminare il condominio '" + condominium.name + " di " + condominium.address.formatted + "?",
			buttons: [
				{
					text: 'Annulla',
					role: 'cancel'
				}, {
					text: 'Elimina',
					handler: () => {
						self.condominiums.destroy(condominium).then((success: boolean) => {
							if(success) {
								let toast = self.toastCtrl.create({
									message: 'Condominio eliminato',
									position: 'middle',
									duration: 3000,
									cssClass: "light"
								})
								toast.present()
							} else {
								let toast = self.toastCtrl.create({
									message: "Potrebbe essersi verificato un errore eliminando il condominio",
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								})
								toast.present()
							}
							this.refresh()
						}).catch(error => {
							console.error("Errore eliminando il condominio", error)
							let toast = self.toastCtrl.create({
								message: "Errore eliminando il condominio",
								position: 'middle',
								duration: 3000,
								cssClass: "danger"
							})
							toast.present()
							this.refresh()
						})
					}
				}
			]
		})
		confirm.present()
	}

	showRemoveRoleConfirm(closable, user: User, role: string) {
		closable.close()
		/*
		let self=this;
		let confirm = this.alertCtrl.create({
		title:"Rimuovere il ruolo utente dal condominio?",
		message: "Vuoi davvero rimuovere il ruolo all'utente '"+user.name+" "+user.surname+"' - "+user.fiscal_code+" "+user.vat_number+"?",
		buttons: [
		{
		text: 'Annulla',
		role:'cancel'
	},{
	text: 'Rimuovi',
	handler: ()=>{
	user[role]=false;
	self.users.update(condominiums).then((user:User)=>{
	if(user&&!user[role]){
	let toast = self.toastCtrl.create({
	message: 'Ruolo rimosso',
	position:'middle',
	duration: 3000,
	cssClass: "light"
});
toast.present();
}else{
let toast = self.toastCtrl.create({
message: "Potrebbe essersi verificato un errore rimuovendo il ruolo",
position:'middle',
duration: 3000,
cssClass: "danger"
});
toast.present();
}
this.refresh();
}).catch(error=>{
console.error("Errore rimuovendo il ruolo",error);
let toast = self.toastCtrl.create({
message:"Errore rimuovendo il ruolo",
position:'middle',
duration: 3000,
cssClass: "danger"
});
toast.present();
this.refresh();
});
}
}
]
});
confirm.present();
*/
	}
}



// WEBPACK FOOTER //
// ./src/pages/condominium-index/condominium-index.ts